module.exports = {"markup":"<span class=\"inline-cross inline-icon\"><svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\"><path d=\"M7.5 9l-6.5-7 1-1 7 6.5 7-6.5 1 1-6.5 7 6.5 7-1 1-7-6.5-7 6.5-1-1 6.5-7z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./dev/webpack-loaders/svg-loader!./static/src/inline-svgs/icon/cross.svg
// module id = 286
// module chunks = 0 17